import { render } from "./Likes.vue?vue&type=template&id=1ed9478a"
import script from "./Likes.vue?vue&type=script&lang=js"
export * from "./Likes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__